import type { ReactElement } from 'react'
import { useIntl } from 'react-intl'
import LandingPageLoyaltyBenefitTile from './LandingPageLoyaltyBenefitTile'
import {
  getLoyaltyBenefitModalPath,
  LOYALTY_AIRPORT_TRANSFER_HASH,
} from 'loyalty/constants/loyaltyRoutes'
import { useAppSelector } from 'hooks/reduxHooks'
import getLoyaltyIsInfiniteAccountTier from 'loyalty/selectors/getLoyaltyIsInfiniteAccountTier'

interface Props {
  layout: 'tile' | 'row'
  benefitLabel: ReactElement
}

function LandingPageLoyaltyAirportTransfersTile(props: Props) {
  const { layout, benefitLabel } = props
  const intl = useIntl()
  const isInfiniteTier = useAppSelector(getLoyaltyIsInfiniteAccountTier)

  const heading = isInfiniteTier
    ? intl.formatMessage({
        id: 'eK7ybYWv_yuo9pi26_wc',
        defaultMessage: 'Infinite chauffeur airport transfers',
        description: 'Heading for the airport chauffeur transfer benefit tile shown to Infinite tier members',
      })
    : intl.formatMessage({
        defaultMessage: 'Free airport chauffeur transfers',
        id: 'OZv7wX049XAjsYi4I9Z2',
        description: 'Heading for loyalty airport chauffeur transfer benefit tile',
      })

  return <LandingPageLoyaltyBenefitTile
    layout={layout}
    benefitType="airport_transfer"
    heading={heading}
    subtitle={benefitLabel}
    to={getLoyaltyBenefitModalPath(LOYALTY_AIRPORT_TRANSFER_HASH)}
  />
}

export default LandingPageLoyaltyAirportTransfersTile
